import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';

export const Hero = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3,
        duration: 0.8,
        ease: "easeOut"
      }
    })
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/APCFORWARD.jpg"
          alt="Grassroots Rally"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-primary-dark/90" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
        <motion.div
          initial="hidden"
          animate="visible"
          className="max-w-4xl space-y-6"
        >
          <motion.p
            custom={0}
            variants={textVariants}
            className="text-xl md:text-2xl font-medium text-green-400 uppercase tracking-wider"
          >
            Mobilizing grassroots nationwide
          </motion.p>

          <motion.h1
            custom={1}
            variants={textVariants}
            className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight"
          >
            GRASSROOTS MOBILIZATION FOR <span className="text-green-500">APC PBAT</span> NATIONWIDE
          </motion.h1>

          <motion.p
            custom={2}
            variants={textVariants}
            className="mx-auto max-w-2xl text-lg md:text-xl text-gray-200 font-bold leading-tight"
          >
            APC: Progress 
          </motion.p>
          
          <motion.p
            custom={3}
            variants={textVariants}
            className="mx-auto max-w-2xl text-lg md:text-xl text-gray-200 font-bold leading-tight"
          >GRASSROOTS: Mobilize to WIN.
          </motion.p>

          <motion.div
            custom={3}
            variants={textVariants}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8"
          >
           
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 transform"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="text-sm text-gray-300">Scroll Down</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="h-6 w-4 rounded-full border-2 border-white/50 flex justify-center p-1"
          >
            <div className="h-1 w-1 bg-white rounded-full" />
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};
